module.exports = __webpack_public_path__ + "static/media/admission.1b6d23f7.jpg";